import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, WashDto } from "@/core/api/generated/v1";

interface Props {
  wash: WashDto;
}

export default function CommentsTabContent({ wash }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat entityId={wash.id!} entityType={EntityType.Wash} entity={wash} />
      </ViewContentBlock>
    </PageTabContent>
  );
}
